import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import PropTypes from "prop-types";

function BarChart({ barChartData = [], barChartOptions = {} }) {
  /* local state */
  const [series, setSeries]   = useState([]);
  const [options, setOptions] = useState({});

  /* keep state in sync with props */
  useEffect(() => {
    setSeries(Array.isArray(barChartData) ? barChartData : []);
    setOptions(barChartOptions || {});
  }, [barChartData, barChartOptions]);

  /* optional: show a placeholder while waiting for data */
  if (series.length === 0) return <div>Loading chart…</div>;

  return (
    <Chart
      options={options}
      series={series}
      type="bar"
      width="100%"
      height="100%"
    />
  );
}

BarChart.propTypes = {
  barChartData: PropTypes.array,   // array of series objects
  barChartOptions: PropTypes.object,  // ApexCharts options
};

export default BarChart;
